<template>
	<el-timeline v-bind="$attrs" v-on="$listeners">
	  <slot></slot>
	</el-timeline>
</template>
<script>
export default {
  name: "aia-timeline",
};
</script>